<template>
  <div>
    <flat-pickr :placeholder="placeholder" :disabled="isDisabled" @input="onInput($event)" :value="value" :config="{
      dateFormat: dateFormat,
      minDate: minValue,
      maxDate: maxValue,
      defaultHour: 0,
      altInput: true,
      altFormat: altFormat,
      enableTime: componentType === 'datetime',
      time_24hr: true,
      enableSeconds: true,
      mode: dateMode,
      onChange: onChange,
      minDate: allowPastDates ? null : 'today'
    }" class="w-full" name="dob" />
  </div>
</template>

<script>

import flatPickr from 'vue-flatpickr-component';

export default {
  name: 'DateField',
  components: {
    flatPickr,
  },
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Array],
      default: ''
    },
    minValue: {
      type: String,
      default: ''
    },
    maxValue: {
      type: String,
      default: ''
    },
    componentType: {
      type: String,
      default: 'date'
    },
    allowPastDates: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      dateValue: '',
      testModel: ''
    };
  },
  methods: {
    onInput(event) {
      this.$emit("input", event);
      // this.$emit("onChange", event);
    },
    onChange(event) {
      let payload = null;
      if(this.componentType === 'multiple_date') {
        const formattedDates = [];
        for(const date of event) {
          const formatted = date.toISOString().slice(0, 10);
          formattedDates.push(formatted);
        }
        payload = formattedDates;
      } else {
        payload = event;
      }

      // this.$emit("onChange", payload);
      // this.$emit("input", ', '.join(payload));
    },
    formatMultipleDate(value) {
      return value
    },
    // Your component methods go here
  },
  computed: {
    dateMode() {
      if (this.componentType === 'multiple_date') {
        return 'multiple'
      } else {
        return 'single'
      }
    },
    dateFormat() {
      if (this.componentType === 'date' || this.componentType === 'multiple_date') {
        return 'Y-m-d'
      } else if (this.componentType === 'datetime') {
        return 'Y-m-d H:i:S'
      }
    },
    altFormat() {
      if (this.componentType === 'date' || this.componentType === 'multiple_date') {
        return 'd/m/Y'
      } else if (this.componentType === 'datetime') {
        return 'd/m/Y H:i:S'
      }
    }
  },
  mounted() {
    // Code to run when the component is mounted
  }
};
</script>

<style scoped>
/* Your component styles go here */
</style>
